module.exports = __webpack_public_path__ + "static/media/NotoSansKR-Medium.4dee649c.ttf";